import {Buffer} from "buffer";

function getTokenInfo(token) {
    let tokens = token.split(".");
    let payload = Buffer.from(tokens[1], "base64").toString();
    let data = decodeURIComponent(escape(payload));
    return JSON.parse(data);
}

export default getTokenInfo;